import React, {useState} from 'react';
import { Flex } from "antd";
import {BackButton} from "../../../../shared";
import {StyledCard} from "./Header.styled";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {HeaderProps} from "../../models";

const Header = ({title} :HeaderProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [activeTitle, setActiveTitle] = useState<string>('')
    const onCansel = () => {
        setOpen(false)
    }
    return (
        <StyledCard>
            <Flex justify={"space-between"} align={"center"} gap={"middle"}>
                <Flex gap={"small"} align={"center"}>
                    <BackButton/>
                    <span>{title}</span>
                </Flex>
                <img width={20} src={require("assets/Logo/logoPink.png")}/>
            </Flex>
        </StyledCard>
    )

};


export default connect(null, {})(
    withRouter(Header)
);
